import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import "moment/min/locales";
import { format, parse } from "date-fns";
import { ptBR } from "date-fns/esm/locale";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import Alarm from "@material-ui/icons/Alarm";
import CalendarToday from "@material-ui/icons/CalendarToday";
import ErrorOutline from "@material-ui/icons/ErrorOutline";
import Button from "@material-ui/core/Button";
import PersonIcon from "@material-ui/icons/Person";
import ConfirmDialog from "./../../components/ConfirmDialog/ConfirmDialog";
import { Receipt } from "../../components/TimeclockReceipt/TimeClockReceiptItem";
import { fetchUser, sendEmail } from "../../store/actions/clockInOut";
import Map from "./utils/MapaDetalhes";
import { Typography } from "@material-ui/core";

const jwt = require("jsonwebtoken");

const styles = (theme) => ({
  button: {
    borderRadius: "20px",
    "&:hover": {
      color: "#FFF",
      backgroundColor: "#3271e7",
    },
    fontWeight: "bold",
  },
  icon: {
    marginLeft: '95px',
    width: '109px',
    height: '100px',
  },
  font: {
    marginLeft: '25px',
    fontSize: '14px',
  },
});

class modalDetails extends React.Component {
  state = {
    open: false,
    user: {
      companies: [],
      socialName: "",
      id: null,
      dtRegister: moment().format("YYYY-MM-DD HH:mm:ss"),
    },
    company: null,
    isChecked: null,
    noMoment: true,
  };


  componentDidMount() {
    this.handleFetchUser();
  }

  setDate = (dtRegister) => {
    const dtRef = new Date(dtRegister)
    const dayforat = dtRef.getDate().toString().padStart(2, '0'); // Dia com zero à esquerda
    const monthformat = (dtRef.getMonth() + 1).toString().padStart(2, '0'); // Mês com zero à esquerda
    const yearformat = dtRef.getFullYear();
    console.log(('data', this.props.data));

    const formattedDate = `${dayforat}/${monthformat}/${yearformat}`;
    const date = parse(formattedDate, "dd/MM/yyyy", new Date());
    // const date = new Date(dtRegister);
    const dayName = format(date, "EEE", { locale: ptBR });
    const day = format(date, "dd", { locale: ptBR });
    const month = format(date, "MMMM", { locale: ptBR });
    const year = format(date, "yyyy", { locale: ptBR });
    const dayDetails = `${dayName}, ${day} de ${month} de ${year}`;
    return dayDetails;
  };

  // setDate = (dtRegister) => {
  //   const date = parse(dtRegister, "dd/MM/yyyy", new Date());
  //   const dayName = format(date, "EEE", { locale: ptBR });
  //   const day = format(date, "dd", { locale: ptBR });
  //   const month = format(date, "MMMM", { locale: ptBR });
  //   const year = format(date, "yyyy", { locale: ptBR });
  //   const dayDetails = `${dayName}, ${day} de ${month} de ${year}`;
  //   return dayDetails;
  // };

  setPointDivergent = (point) => {
    const messages = [];
    let warning = "Ponto ";
    const and = " e ";

    if (point && point.hasLocationRestrictDivergence) {
      messages.push("fora do local");
    }

    if (point && point.hasPhotoRequiredDivergence) {
      messages.push("sem foto");
    }

    if (point && point.markOffScaleDivergence) {
      messages.push("fora da escala");
    }

    messages.forEach((m, index) => {
      if (messages.length > 1) {
        // se for a partir do 2
        if (index === messages.length - 1) {
          warning = warning + and + m;
        } else if (index === messages.length - 2) warning += m;
        else {
          warning = warning + m + ", ";
        }
      } else {
        warning += m;
      }
    });

    return (
      <div style={{ display: "flex", alignItems: "center", maxWidth: 260 }}>
        <ErrorOutline color="secondary" />
        <text style={{ fontSize: 14, paddingLeft: 5 }}>{`${warning}`}</text>
      </div>
    );
  };

  handleFetchUser = () => {
    const decodedToken = jwt.decode(this.props.token);
    this.props
      .onFetchUser(decodedToken.cpf)
      .then((response) => {
        this.setState({
          user: response,
          company: response.companies.length && response,
        });
      })
      .catch((error) => error);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  verifyCheck = (Checked) => {
    this.setState({ isChecked: Checked });
  };


  onSendEmail = () => {
    this.props.sendEmail(this.props.data.timeclock.id, this.props.token);
    this.setState({ open: false });
    this.props.handleClose();
  };


  render() {
    const { onClose, data, classes, handleClose, ...other } = this.props;
    const coords = [{ lat: data ? data.isRemake ? "" : data.timeclock.lat : "", lng: data ? data.isRemake ? "" : data.timeclock.lng : "" }];
    const ramake = data ? data.isRemake : false
    return (
      <Dialog
        onClose={handleClose}
        maxWidth="xs"
        aria-labelledby="simple-dialog-title"
        {...other}
      >
        <DialogTitle>Detalhes</DialogTitle>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ width: 300, marginBottom: 20 }}>
            {ramake ?
              <Typography>
                <PersonIcon className={classes.icon} />
                <Typography className={classes.font}>Ponto inserido ou alterado pelo gestor</Typography>
              </Typography>
              :

              (<Map
                locations={coords}
                center={[data ? data.isRemake ? "" : data.timeclock.lat : "", data ? data.isRemake ? "" : data.timeclock.lng : ""]}
              />
              )}
          </div>
          <div />
          <div
            style={{
              padding: "0 15px 20px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <CalendarToday />
              <text style={{ fontSize: 14, paddingLeft: 5 }}>
                {data ? data.timeclock ? this.setDate(data.timeclock.dtRegister) : this.setDate(data.dtRegister) : ""}
              </text>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <Alarm />
              <text style={{ fontSize: 14, paddingLeft: 5 }}>
                {data ? data.timeclock ? new Date(data.timeclock.dtRegister).getUTCHours().toString().padStart(2, '0') + ':' + new Date(data.timeclock.dtRegister).getUTCMinutes().toString().padStart(2, '0') :
                  new Date(data.dtRegister).getUTCHours().toString().padStart(2, '0') + ':' + new Date(data.dtRegister).getUTCMinutes().toString().padStart(2, '0') : ""}
                <text style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                  {" "}
                  {data && data.timeclock.type === "I" ? "(entrada)" : "(saída)"}{" "}
                </text>
              </text>
            </div>

            {/* {this.setPointDivergent(data)} */}

            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: 15 }}
              className={classes.button}
              onClick={this.onSendEmail}
            >
              Enviar por email
            </Button>
          </div>
        </div>
        <ConfirmDialog
          open={this.state.open}
          title="Comprovante"
          confirmText="Enviar por email"
          closeText="FECHAR"
          onClose={this.handleClose}
          onConfirm={this.onSendEmail}
          content={
            <Receipt
              noEmail
              data={data}
              user={this.state.company}
              checked={this.verifyCheck}
              company={this.state.company ? this.state.company.companies : []}
            />
          }
        />
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchUser: (cpf) => dispatch(fetchUser(cpf)),
  sendEmail: (timeclockId, token) => dispatch(sendEmail(timeclockId, token)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(modalDetails));
